<template>
  <div id="app">
    <a-config-provider :locale="zhCN" :update-at-scroll="true">
      <!--      <router-view v-slot="{ Component }">-->
      <!--        <keep-alive :include="['services-expert']">-->
      <!--          <component :is="Component" />-->
      <!--        </keep-alive>-->
      <!--      </router-view>-->
      <!--      <keep-alive :include="['services-expert']">-->
      <router-view />
      <!--      </keep-alive>-->
    </a-config-provider>
  </div>
</template>

<script setup lang="ts">
import zhCN from '@arco-design/web-vue/es/locale/lang/zh-CN'
</script>
<style scoped>
#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
